import React, { useState } from 'react';
import { Alert, Col, Input, InputNumber, Modal, notification, Row, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import axios from 'axios';
import env from '../../environment';
import { isMobileOnly } from 'react-device-detect';

const { Text } = Typography;

const AlertPassword = ({}) => {
	const { t } = useTranslation();

	const [modalShowPin, setModalShowPin] = useState(false);
	const [modalShowPhone, setModalShowPhone] = useState(false);
	const [modalShowPasswd, setModalShowPasswd] = useState(false);

	const dataProfile = useSelector((state) => state.data.dataProfile);
	const [error, setError] = useState(undefined);

	const [password1, setPassWord1] = useState(undefined);
	const [password2, setPassWord2] = useState(undefined);
	const [samePassword, setSamePassword] = useState(undefined);
	const [numberPhone, setNumberPhone] = useState(dataProfile.phone);
	const userToken = useSelector((state) => state.auth.token);
	const [pin, setPin] = useState(undefined);
	const [token, setToken] = useState(undefined);

	const modalPhone = () => {
		setModalShowPhone(!modalShowPhone);
	};

	const changeNumber = (value) => {
		setNumberPhone(value);
	};

	const modalPin = () => {
		axios
			.post(
				`${env.api.url}/v1/user/update-phone-number`,
				{
					phone: numberPhone.toString()
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				if (response.data.errorCode === 'PHONE_ALREADY_EXISTS') {
					notification.error({
						message: 'Error al enviar',
						description: 'El telefono ya existe'
					});
				} else {
					axios
						.post(
							`${env.api.url}/v1/user/otp/send`,
							{ managementCode: process.env.REACT_APP_BRAND_MANAGEMENT },

							{
								headers: { Authorization: `Bearer ${userToken}` }
							}
						)
						.then(() => {
							setModalShowPhone(false);
							setModalShowPin(!modalShowPin);
						});
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const sendPin = (value) => {
		setPin(value);
	};

	const handlePassword = () => {
		axios
			.post(
				`${env.api.url}/v1/users/otp/verify`,
				{ otp: pin.toString() },

				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				if (response.data.errorCode === 'USER_OTP_NOT_FOUND') {
					setError(1);
				} else if (response.data.errorCode === 'USER_OTP_EXPIRED') {
					setError(2);
				} else {
					setToken(response.data);
					setModalShowPin(!modalShowPin);
					setModalShowPasswd(!modalShowPasswd);
				}
			});
	};

	const sendPasswd = () => {
		if (password1 !== password2) {
			setSamePassword('error');
		} else {
			axios
				.post(
					`${env.api.url}/v1/auth/reset-password`,
					{
						token: token.data.token,
						email: dataProfile.email,
						password: password1,
						managementCode: process.env.REACT_APP_BRAND_MANAGEMENT
					},

					{
						headers: { Authorization: `Bearer ${userToken}` }
					}
				)
				.then(() => {
					setModalShowPasswd(!modalShowPasswd);
					notification.success({
						message: (
							<Text style={{ color: '#3E9314', fontSize: 16, fontWeight: 600 }}>
								{t('modal.showPasswdSaved')}
							</Text>
						),
						description: (
							<Text
								style={{
									color: '#2F4858',
									fontSize: 14,
									fontWeight: 400
								}}>
								{t('modal.showPasswdSavedOk')}
							</Text>
						),
						duration: 0,
						style: {
							background: '#DFF4D4',
							borderColor: '#52C41A',
							borderRadius: 4
						}
					});

					setTimeout(() => {
						window.location.reload();
					}, 2000);
				});
		}
	};

	return (
		<>
			<Modal
				className={isMobileOnly ? 'ModalCommonSmall' : 'ModalCommon'}
				cancelButtonProps={{
					className: 'button-secundary-gibobs',
					style: { width: '46%' }
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { width: '46%' }
				}}
				open={modalShowPhone}
				title={t('modal.passwordMobile')}
				okText={t('modal.passwordMobileAceptar')}
				cancelText={t('offers.cancel')}
				width={480}
				onCancel={() => {
					setModalShowPhone(!modalShowPhone);
				}}
				onOk={() => {
					modalPin();
				}}>
				<div style={{ marginTop: -30 }}>
					<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
						{t('modal.passwordMobileText')}
					</Text>
					<InputNumber
						onChange={(e) => changeNumber(e)}
						defaultValue={numberPhone && numberPhone}
						style={{ marginTop: 16, height: 40, borderColor: '#C0DAEE' }}></InputNumber>
				</div>
			</Modal>
			<Modal
				className={isMobileOnly ? 'ModalCommonSmall' : 'ModalCommon'}
				cancelButtonProps={{
					className: 'button-secundary-gibobs',
					style: {
						width: '46%',
						display: error !== undefined ? 'none' : undefined
					}
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { width: error !== undefined ? '95%' : '46%' }
				}}
				open={modalShowPin}
				title={t('modal.showPinTlfTitle')}
				okText={error !== undefined ? t('m_common.close') : t('viability.myInterest')}
				cancelText={t('offers.cancel')}
				width={480}
				onCancel={() => {
					setModalShowPin(!modalShowPin);
				}}
				onOk={() => {
					error ? setModalShowPin(false) : handlePassword();
				}}>
				{error === undefined && (
					<div style={{ marginTop: -30 }}>
						<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
							{t('modal.showPinTlf')}
						</Text>
						<InputNumber
							type="password"
							onChange={(e) => sendPin(e)}
							placeholder="Código"
							style={{ marginTop: 16, height: 40, borderColor: '#C0DAEE' }}></InputNumber>
					</div>
				)}

				{error === 1 && (
					<div style={{ marginTop: -30 }}>
						<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
							{t('modal.showPinTlf')}
						</Text>
						<Input
							status="error"
							placeholder="Código"
							style={{
								marginTop: 16,
								height: 40,
								borderColor: '#FF4D4F',
								width: '100%'
							}}></Input>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Text style={{ color: '#FF4D4F', fontSize: 12, fontWeight: 400 }}>
								{t('modal.showPinError')}
							</Text>
							<Text
								style={{
									color: '#748EA0',
									fontSize: 14,
									fontWeight: 400,
									marginTop: 16
								}}>
								{t('modal.showPinErrorEmail') +
									' ' +
									dataProfile.email +
									' ' +
									t('modal.showPinErrorEmail2')}
							</Text>
						</div>
					</div>
				)}
				{error === 2 && (
					<div style={{ marginTop: -30 }}>
						<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
							{t('modal.showPinTlf')}
						</Text>
						<Input
							status="error"
							placeholder="Código"
							style={{
								marginTop: 16,
								height: 40,
								borderColor: '#FF4D4F',
								width: '100%'
							}}></Input>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Text style={{ color: '#FF4D4F', fontSize: 12, fontWeight: 400 }}>
								{t('modal.showPinErrorEmail4')}
							</Text>
							<Text
								style={{
									color: '#748EA0',
									fontSize: 14,
									fontWeight: 400,
									marginTop: 16
								}}>
								{t('modal.showPinErrorEmail3') +
									' ' +
									dataProfile.email +
									' ' +
									t('modal.showPinErrorEmail2')}
							</Text>
						</div>
					</div>
				)}
			</Modal>
			<Modal
				className={isMobileOnly ? 'ModalCommonSmall' : 'ModalCommon'}
				cancelButtonProps={{
					className: 'button-secundary-gibobs',
					style: { width: '46%' }
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { width: '46%' }
				}}
				open={modalShowPasswd}
				title={t('modal.showPinTlfTitle')}
				okText={t('offers.accept')}
				cancelText={t('offers.cancel')}
				width={480}
				onCancel={() => {
					setModalShowPasswd(!modalShowPasswd);
				}}
				onOk={() => {
					sendPasswd();
				}}>
				<div style={{ marginTop: -30 }}>
					<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
						{t('modal.showPasswdInput')}
					</Text>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<Input
							type="password"
							onChange={(e) => setPassWord1(e.target.value)}
							placeholder={t('modal.showPasswdPlace')}
							style={{
								marginTop: 16,
								height: 40,
								borderColor: '#C0DAEE',
								width: '100%'
							}}></Input>

						{samePassword === undefined && (
							<Input
								type="password"
								onChange={(e) => setPassWord2(e.target.value)}
								placeholder={t('viability.confirmButton') + ' ' + t('modal.showPasswdPlace')}
								style={{
									marginTop: 16,
									height: 40,
									borderColor: '#C0DAEE',
									width: '100%'
								}}></Input>
						)}

						{samePassword === 'error' && (
							<div>
								<Input
									type="password"
									onChange={(e) => setPassWord2(e.target.value)}
									placeholder={t('viability.confirmButton') + ' ' + t('modal.showPasswdPlace')}
									style={{
										marginTop: 16,
										height: 40,
										borderColor: '#FF4D4F',
										width: '100%'
									}}></Input>
								<Text style={{ color: '#FF4D4F', fontSize: 12, fontWeight: 400 }}>
									{t('modal.showPasswdSome')}
								</Text>
							</div>
						)}
					</div>
				</div>
			</Modal>
		</>
	);
};
export default AlertPassword;
